import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/my.png";
import Tilt from "react-parallax-tilt";
import "./Home.css";
import {
  AiFillGithub,
  AiFillDribbbleCircle,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am final year undergraudate student of <b className="purple"> Computer Science </b> at University of Engineering & Technology, Lahore (UET Lahore) 🤷‍♂️
              <br />
              <br />I love to explore new technologies and leverage them to solve real-life problems. I am a passionate learner and always ready to learn and work across technologies and domains 💡
              <br />
              <br />
              I am currently working on my <b className="purple">MERN</b> stack skills and exploring new technologies. I am also open to any <b className="purple">Web Development</b> and <b className="purple">UI/UX Design</b> opportunities.
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">HTML/CSS</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid tilted-img" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/mubashar-nouman"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://dribbble.com/mubashirrnouman"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillDribbbleCircle />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/mubashar-nouman/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/mubashar_dev/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
